import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink'; // @ts-expect-error no types from package

import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { SSO_KNOWLEDGE_BASE_DOCUMENT } from '../../constants/KnowledgeBaseUrls';
import { NO_RECORD_ERROR, SAML_ERROR } from '../../constants/ErrorValues';
const errorMessageComponents = {
  [NO_RECORD_ERROR]: FormattedJSXMessage,
  [SAML_ERROR]: FormattedReactMessage
};
const errorMessageProps = {
  [NO_RECORD_ERROR]: props => ({
    message: 'login.errors.NO_RECORD.body_jsx',
    options: {
      href: props && props.signUpLink
    },
    elements: {
      Link: UILink
    }
  }),
  [SAML_ERROR]: () => ({
    options: {
      knowledgeBaseButton: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        url: SSO_KNOWLEDGE_BASE_DOCUMENT
      })
    }
  })
};

const ErrorMessage = props => {
  const {
    error,
    fallbackError,
    prefix,
    type
  } = props;

  if (!error) {
    return /*#__PURE__*/_jsx("div", {});
  }

  let i18nKey = `${prefix}.${error}`;

  if (!isValidI18nKey(`${i18nKey}.title`)) {
    i18nKey = `${prefix}.${fallbackError}`;
  }

  const ErrorMessageComponent = errorMessageComponents[error] || FormattedHTMLMessage;
  const messageProps = Object.assign({
    message: `${i18nKey}.body`
  }, errorMessageProps[error] ? errorMessageProps[error](props) : {});
  return /*#__PURE__*/_jsx(UIAlert, {
    className: "m-bottom-4 text-left",
    "data-error-type": error,
    titleText: I18n.text(`${i18nKey}.title`),
    type: type,
    children: /*#__PURE__*/_jsx(ErrorMessageComponent, Object.assign({}, messageProps))
  });
};

ErrorMessage.propTypes = {
  error: PropTypes.string,
  fallbackError: PropTypes.string,
  prefix: PropTypes.string,
  signUpLink: PropTypes.string,
  type: PropTypes.string
};
ErrorMessage.defaultProps = {
  fallbackError: 'LOGIN_UNAVAILABLE',
  prefix: 'login.errors',
  type: 'danger'
};
export default ErrorMessage;